import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AddOnOrderService } from 'app/modules/add-on-orders/services/add-on-order.service';
import { InsuranceService } from 'app/modules/insurance/services/insurance.service';
import { OrderService } from 'app/modules/order/services/order.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { GTMDataLayerService } from 'app/shared/services/gtmDataLayer.service';
import { CryptoUtils } from 'app/shared/utility/crypto.utils';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'payment-failed',
  templateUrl: './payment-failed.component.html',
  styleUrls: [
    './payment-failed.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaymentFailedComponent implements OnInit {

  public orderId: string;
  public orderDetails: any;
  public showLoader: boolean = true;
  public paymentStatus: any;
  public paymentMode: any;
  public forexMarginString: String = '0.00';
  public cryptoUtils: CryptoUtils = new CryptoUtils();
  public insuranceDetails: any;
  public insuranceId: any;
  public orderType: any = "FOREX_ORDER";
  public insurancePlan: string = "";
  public xplorerOrderDetail: any;

  constructor(
    private route: ActivatedRoute,
    public orderService: OrderService,
    private router: Router,
    public insuranceService: InsuranceService,
    public toast: ToastrService,
    public addOnOrderService: AddOnOrderService,
    public gtmPushService: GTMDataLayerService,) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.orderId = params['orderId'];
    });

    this.getSingleOrderDetails();
  }

  getSingleOrderDetails() {
    this.showLoader = true;
    if(localStorage.getItem(ConstantsKey.IS_STUD_REMITTANCE_ORDER_DONE)) {
      localStorage.removeItem(ConstantsKey.IS_STUD_REMITTANCE_ORDER_DONE)
    } 
    if(localStorage.getItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE)) {
      localStorage.removeItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE)
    }
    if(localStorage.getItem(ConstantsKey.IS_CARD_ORDER_DONE)) {
      localStorage.removeItem(ConstantsKey.IS_CARD_ORDER_DONE)
    }

      if (this.orderId && this.orderId.toString().toLowerCase().startsWith('x')) {
      if(localStorage.getItem(ConstantsKey.IS_ONLY_XPLORER_PURCHASE)) {
            localStorage.removeItem(ConstantsKey.IS_XPLORER_ORDER_DONE);
          }          
            this.orderService.getXplorerOrderDetail(this.orderId).subscribe(resp => {
              this.orderDetails = resp.body;
              this.xplorerOrderDetail = (resp.body as any)?.order;
                  this.showLoader = false;

            }, err => {
              this.showLoader = false;
              this.toast.error(err.error.message);
            });
    }else  {
    this.orderService.getOrderDetailsSingle(this.orderId).subscribe(respOrderData => {
      if (respOrderData['status'] == 200) {
        this.showLoader = false;
        this.orderDetails = respOrderData.body;
        this.paymentStatus = this.orderDetails?.orderStatusGroup?.consumerPayment;
        this.paymentMode = this.orderDetails?.paymentMode;
        if (this.orderDetails?.invoice?.marginCharges!=null) {
         this.forexMarginString = this.orderDetails?.invoice?.marginCharges.toFixed(2) + "";
        }

      

      }
    }, error => {
      this.showLoader = false;


      let orderData = localStorage.getItem(ConstantsKey.CURRENT_ORDER_TYPE);
      console.log("orderData ------------------- ", orderData);
     

      if(orderData) {
        let parseOrderData = JSON.parse(orderData);
        this.orderType = parseOrderData["ORDER_TYPE"];

        if(this.orderType == "INSURANCE") {
          if(localStorage.getItem(ConstantsKey.IS_INSURANCE_ORDER_DONE)) {
            localStorage.removeItem(ConstantsKey.IS_INSURANCE_ORDER_DONE);
          }                    
          this.insuranceService.getTravelInsuranceCartDetails(this.orderId).subscribe(respInsuranceData => {
            this.showLoader = false;
            this.insuranceDetails = respInsuranceData.body;
            this.insuranceId = this.insuranceDetails.cart[0].insuranceOrderId;
          }, error => {
            this.insuranceDetails = JSON.parse(this.cryptoUtils.resDecrypt(error.error.text));
            this.insuranceId = this.insuranceDetails.cart[0].insuranceOrderId;
            this.insurancePlan = this.insuranceDetails.cart[0].planName;
            console.log('INSURANCE DETAILS >>> ', JSON.stringify(this.insuranceDetails));
          });
        } else if(this.orderType == "ESIM") {
          if(localStorage.getItem(ConstantsKey.IS_ESIM_ORDER_DONE)) {
            localStorage.removeItem(ConstantsKey.IS_ESIM_ORDER_DONE);
          }
          this.addOnOrderService.getEsimOrderDetails(this.orderId).subscribe(resp => {
            this.showLoader = false;
            this.orderDetails = resp.body;

            },err => {
              this.showLoader = false;
              this.toast.error(err.error.message);
            });

        } else if(this.orderType == "LOUNGE") {
          if(localStorage.getItem(ConstantsKey.IS_LOUNGE_ORDER_DONE)) {
            localStorage.removeItem(ConstantsKey.IS_LOUNGE_ORDER_DONE);
          }          
            this.addOnOrderService.getLoungeOrderDetails(this.orderId).subscribe(resp => {
              this.orderDetails = resp.body;
            }, err => {
              this.showLoader = false;
              this.toast.error(err.error.message);
            });
        } else if(this.orderType == "XPLORER_CARD") {
          if(localStorage.getItem(ConstantsKey.IS_ONLY_XPLORER_PURCHASE)) {
            localStorage.removeItem(ConstantsKey.IS_XPLORER_ORDER_DONE);
          }          
            this.orderService.getXplorerOrderDetail(this.orderId).subscribe(resp => {
              this.orderDetails = resp.body;
              this.xplorerOrderDetail = (resp.body as any)?.order;
            }, err => {
              this.showLoader = false;
              this.toast.error(err.error.message);
            });
        }


      }
    });
  }
  }

  navigateToRating() {
    this.router.navigate(['/ratings', this.orderId]);
  }

  retryPayment() {
    this.router.navigate(['/retry-payment', this.orderId]);
  }

  goToOrderDetails() {
    if(this.xplorerOrderDetail) {
      this.router.navigate(['/add-on/order-details/xplorer', this.orderId]);
    } else if(this.orderType == 'FOREX_ORDER') {
      this.router.navigate(['/order-details', this.orderId]);
    } else if( this.orderType == 'INSURANCE') {
      this.router.navigate(['/insurance-details', this.orderId]);
    } else if(this.orderType == "LOUNGE") {
      this.router.navigate(['/add-on/order-details', this.orderType.toLocaleLowerCase(),this.orderId]);
    } else if(this.orderType == "ESIM") {
      this.router.navigate(['/add-on/order-details', this.orderType.toLocaleLowerCase(), this.orderId]);
    } else if(this.orderType == "XPLORER_CARD") {
      this.router.navigate(['/add-on/order-list/xplorer']);
    }

  }

  goToInsuranceDetails() {
    // this.router.navigate(['/insurance-list']);
    this.router.navigate(['/insurance-details', this.insuranceId]);
  }
}